document.addEventListener('DOMContentLoaded', () => {
    ACCORDION.onReady();
    AOS.init();
    APP.onReady();
    BULMA.onReady();
    CLEAN.onReady();
    DROPDOWN.onReady();
    DOWNLOAD.onReady();
    FILEPOND.onReady();
    FORM.onReady();
    MODAL.onReady();
    NAV.onReady();
    SCROLLER.onReady();
    TABS.onReady();
    TINYSLIDER.onReady();
});